import { MAX_PAGE_WIDTH } from '@/constants/shared';
import { AmplitudeTrackingEvent, trackAmplitudeEvent } from '@/lib/amplitude';
import { HStack, Icon, Image, Link, Stack, Text, VStack } from '@chakra-ui/react';
import { FaDiscord, FaTelegram } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';
import { NavButton } from './nav-button';

const FooterLink = ({ href, children }: { href: string; children: React.ReactNode }) => {
  return (
    <Link
      target={href.startsWith('http') ? '_blank' : '_self'}
      href={href}
      onClick={() =>
        trackAmplitudeEvent(AmplitudeTrackingEvent.ClickedFooter, {
          link: href,
        })
      }
    >
      {children}
    </Link>
  );
};

export const Footer = () => {
  return (
    <VStack justifyContent="space-between" w="full" gap={16} mt={32} fontWeight="500" fontSize="sm">
      <Stack justifyContent="space-between" direction="row" maxW={MAX_PAGE_WIDTH} w="full">
        <VStack alignItems="start">
          <Text color="fg.muted">Plume</Text>
          <FooterLink href="https://docs.plumenetwork.xyz/plume#about-us">About</FooterLink>
          <FooterLink href="https://docs.plumenetwork.xyz/plume/plume-overview/architecture">Chain</FooterLink>
          <FooterLink href="https://plumenetwork.xyz/arc">Arc</FooterLink>
          <FooterLink href="https://plumenetwork.xyz/nexus">Nexus</FooterLink>
          <FooterLink href="https://plumenetwork.xyz/pusd">pUSD</FooterLink>
          <FooterLink href="https://nest.credit">Nest</FooterLink>
        </VStack>
        <VStack alignItems="start">
          <Text color="fg.muted">Resources</Text>
          <FooterLink href="https://plumenetwork.xyz/blog">Blog</FooterLink>
          <FooterLink href="https://docs.plumenetwork.xyz/plume">Documentation</FooterLink>
          <FooterLink href="https://plumenetwork.xyz/media-kit">Brand Kit</FooterLink>
        </VStack>
        <VStack alignItems="start">
          <Text color="fg.muted">Legal</Text>
          <FooterLink href="https://plumenetwork.xyz/privacy-policy">Privacy Policy</FooterLink>
          <FooterLink href="https://plumenetwork.xyz/terms-of-service">Terms of Service</FooterLink>
        </VStack>
      </Stack>
      <HStack justifyContent="space-between" w="full" maxW={MAX_PAGE_WIDTH}>
        <Image src="/assets/plume-logo.svg" />
        <HStack>
          <NavButton
            variant="ghost"
            href="/profile/0xDE1509CC56D740997c70E1661BA687e950B4a241"
            p={0}
            onClick={() =>
              trackAmplitudeEvent(AmplitudeTrackingEvent.ClickedFooter, {
                link: 'eugene',
              })
            }
          >
            <Image src="/assets/dove.svg" boxSize={6} />
          </NavButton>
          <NavButton
            variant="ghost"
            href="https://x.com/plumenetwork"
            target="_blank"
            p={0}
            onClick={() =>
              trackAmplitudeEvent(AmplitudeTrackingEvent.ClickedFooter, {
                link: 'twitter',
              })
            }
          >
            <Icon boxSize={6} color="fg.muted">
              <FaXTwitter />
            </Icon>
          </NavButton>
          <NavButton
            variant="ghost"
            href="https://discord.com/invite/plume-network"
            target="_blank"
            p={0}
            onClick={() =>
              trackAmplitudeEvent(AmplitudeTrackingEvent.ClickedFooter, {
                link: 'discord',
              })
            }
          >
            <Icon boxSize={6} color="fg.muted">
              <FaDiscord />
            </Icon>
          </NavButton>
          <NavButton
            variant="ghost"
            href="https://t.me/plumenetwork_community"
            target="_blank"
            p={0}
            onClick={() =>
              trackAmplitudeEvent(AmplitudeTrackingEvent.ClickedFooter, {
                link: 'telegram',
              })
            }
          >
            <Icon boxSize={6} color="fg.muted">
              <FaTelegram />
            </Icon>
          </NavButton>
        </HStack>
      </HStack>
    </VStack>
  );
};
